import moment from 'moment';

export default class AvailabilityPeriodModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.start = data.start ? moment(data.start).toDate() : null;
    this.end = data.end ? moment(data.end).toDate() : null;
  }
}
